module.exports = __webpack_public_path__ + "img/yiyao_kunming_suoluetu.54841763.png";